import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link, useLocation } from 'react-router-dom';
import { useIsMobile } from '../hooks/useIsMobile';
const tabs = [
    { path: '/my-jobs', label: 'My Work', icon: '📋' },
    { path: '/tasks', label: 'Tasks', icon: '🗂️' },
    { path: '/estimates', label: 'Estimates', icon: '📝' },
    { path: '/projects', label: 'Projects', icon: '🔧' },
    { path: '/customers', label: 'Customers', icon: '👥' },
    { path: '/installers', label: 'Team', icon: '👷' },
    { path: '/suppliers', label: 'Suppliers', icon: '🏭' },
];
export const BottomNav = () => {
    const isMobile = useIsMobile();
    const location = useLocation();
    if (!isMobile)
        return null;
    return (_jsx("nav", { style: styles.nav, children: _jsx("div", { style: styles.scroll, children: tabs.map((tab) => {
                const isActive = location.pathname === tab.path;
                return (_jsxs(Link, { to: tab.path, style: { ...styles.tab, color: isActive ? '#0071e3' : '#86868b' }, children: [_jsx("span", { style: styles.icon, children: tab.icon }), _jsx("span", { style: styles.label, children: tab.label })] }, tab.path));
            }) }) }));
};
const styles = {
    nav: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        height: '64px',
        backgroundColor: 'rgba(255, 255, 255, 0.92)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        borderTop: '1px solid rgba(0, 0, 0, 0.1)',
        zIndex: 1000,
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
        scrollbarWidth: 'none',
    },
    scroll: {
        display: 'flex',
        alignItems: 'center',
        height: '64px',
        minWidth: 'max-content',
        padding: '0 4px',
    },
    tab: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '2px',
        textDecoration: 'none',
        minWidth: '72px',
        height: '100%',
        padding: '0 4px',
    },
    icon: {
        fontSize: '20px',
        lineHeight: 1,
    },
    label: {
        fontSize: '10px',
        fontWeight: '500',
        lineHeight: 1,
    },
};
//# sourceMappingURL=BottomNav.js.map